module.exports = __webpack_public_path__ + "img/nt15-08-75-1.prt.cb9fc874.jpg";